import React from "react"
import cx from "classnames"
import { countries } from "../../tokens"

import * as flags from "../../icons/countries"
import { eqSet } from "../utils"

if (
  !eqSet<string>(
    new Set(Object.keys(flags)),
    new Set(Object.keys(countries.flags))
  )
)
  throw new Error(
    "Flag sources and tokens are not consistent. Did you add the source and export it"
  )

interface FlagsMap {
  [name: string]: string
}

export const BUNDLED_FLAGS: FlagsMap = Object.freeze(
  Object.keys(countries.flags).reduce(
    (bundledFlags, name) => ({
      ...bundledFlags,
      [name]: (flags as FlagsMap)[name],
    }),
    {}
  )
)

export interface FlagProps {
  country: string
  className?: string
  /**
   * Available size in px
   * @default 24
   */
  size?: 16 | 20 | 24 | 32
}

export const Flag = ({ country, size = 24, className }: FlagProps) => {
  const _className = cx("cobalt-Flag", className, {
    "cobalt-Flag--size16": size === 16,
    "cobalt-Flag--size20": size === 20,
    "cobalt-Flag--size32": size === 32,
  })

  const countryFlag = BUNDLED_FLAGS[country]

  if (countryFlag == null)
    throw new Error(
      `'${country}' Flag can not be found. Did you add the source and export it`
    )

  return (
    <span
      className={_className}
      dangerouslySetInnerHTML={{ __html: countryFlag }}
    />
  )
}
